import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {
  ButtonComponent,
  InputDirective,
  InputGroupComponent,
  InputLabelComponent,
  MODAL_DATA,
  ModalRef,
} from '@sms-ir/ui-components';

import {SharedService} from '../../services/shared.service';
import {ValidatorsService} from '../../services/validators.service';
import {FormValidationHelperService} from '../../services/form-validation-helper.service';

export interface OneInputModalData {
  svg?: string;
  modalHeader: string;
  modalText: string;
  modalConfirmButton?: string;
  modalCancelButton?: string;
  initialValue?: string;
  inputConf?: {
    placeholder?: string;
    maxLength?: number;
    minLength?: null;
    type?: string;
  };
}

@Component({
  selector: 'app-one-input-modal',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    ButtonComponent,
    InputDirective,
    InputGroupComponent,
    InputLabelComponent,
  ],
  templateUrl: './one-input-modal.component.html',
  styleUrls: ['./one-input-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OneInputModalComponent implements OnInit {
  private readonly modalRef = inject<ModalRef<string | false>>(ModalRef);
  private readonly data = inject<OneInputModalData>(MODAL_DATA);
  private readonly formBuilder = inject(FormBuilder);
  private readonly validatorsService = inject(ValidatorsService);
  private readonly formValidationHelper = inject(FormValidationHelperService);
  readonly sharedService = inject(SharedService);

  readonly modalHeader = this.data.modalHeader;
  readonly modalText = this.data.modalText;
  readonly modalConfirmButton = this.data.modalConfirmButton;
  readonly modalCancelButton = this.data.modalCancelButton;
  readonly svg = this.data.svg;
  readonly inputConf = this.data.inputConf;
  readonly initialValue = this.data.initialValue;

  modalForm: FormGroup = this.formBuilder.group({
    text: new FormControl('', [this.validatorsService.required()]),
  });

  ngOnInit(): void {
    if (this.initialValue !== undefined) {
      this.modalForm.controls.text.patchValue(this.initialValue);
    }
  }

  onSubmit(): void {
    if (!this.formValidationHelper.validateAndScroll(this.modalForm)) {
      return;
    }
    this.modalRef.close(this.modalForm.controls.text.value);
  }

  onCancel(): void {
    this.modalRef.close(false);
  }
}
